import { useContext, createContext } from 'react';

import { SharedFieldDnDContextValue } from './types';

export const SharedFieldDnDContext =
  createContext<SharedFieldDnDContextValue | null>(null);

export const useSharedFieldDnDContext = () => useContext(SharedFieldDnDContext);
